import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getLorenzFormLayoutEnumString, LibFormValidityDotComponent, LorenzFormComponentDisplayOptions, LorenzFormComponentOptionsDefault, LorenzFormControl, LorenzFormGroup, LorenzFormLayoutEnum } from '@lib/forms';
import { TranslateModule } from '@ngx-translate/core';

// TODO: Lokalisieren

@Component({
	selector: 'lib-form-control-datetime',
	imports: [CommonModule, FormsModule, ReactiveFormsModule, NgClass, LibFormValidityDotComponent, TranslateModule],
	templateUrl: './lib-form-control-datetime.component.html',
	styleUrl: './lib-form-control-datetime.component.scss'
})
export class LibFormControlDatetimeComponent implements OnInit {
	@Input({ required: true, alias: 'control' }) lorenzFormControl!: LorenzFormControl;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentDisplayOptions: LorenzFormComponentDisplayOptions = {};

	@Input({ required: false }) type: 'date' | 'time' = 'date';

	@Input({ required: false }) value = '';

	@HostBinding('attr.class') hostCssClass = '';

	lorenzFormGroup!: LorenzFormGroup;

	ngOnInit() {
		this.lorenzFormGroup = this.lorenzFormControl.parent as LorenzFormGroup;

		this.lorenzFormControl.payload.displayOptions = this.lorenzFormComponentDisplayOptions;

		// prettier-ignore
		this.hostCssClass = [
				getLorenzFormLayoutEnumString(this.lorenzFormComponentDisplayOptions?.layout ?? null),
				this.lorenzFormControl.getKey()
			].join(' ');

		this.value = this.value ? this.value : this.lorenzFormControl.value;
		this.value = this.value ? this.value : this.lorenzFormControl.payload?.initValue;

		this.lorenzFormControl.patchValue(this.value);

		this.lorenzFormControl.updateValueAndValidity();
	}

	get isLayoutFloatingLabels(): boolean {
		return this.lorenzFormComponentDisplayOptions?.layout === LorenzFormLayoutEnum.FLOATING_LABELS;
	}

	get showErrorMessages(): boolean {
		return this.lorenzFormControl.showErrors() && (this.lorenzFormComponentDisplayOptions.showErrorMessages ?? LorenzFormComponentOptionsDefault.showErrorMessages);
	}
}
